import React, { useMemo, useState } from 'react'
import { SelfRegisterHeroImage } from './components/self-register-hero-image'
import { useApFormSelfRegister } from '../../api-new/state/content'
import { useLoad } from '../../shared/hooks/load'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min'
import { SelfRegisterForm } from './components/self-register-form'
import { SelfRegisterResult } from './components/self-register-result'
import { Footer } from '../../page/component/footer'

export const SIGNUP_FAILED = "We couldn't sign you up. Try again."

// Core's catch-all body ({ message: 'an error occured' }) says nothing ours
// doesn't.
const GENERIC = /^an? error occu?rr?ed\.?$/i

// What a refused sign-up says: the server's own sentence -- content's 409
// for an address at a domain whose organization requires single sign-on
// ("Your organization signs in with Contoso. Use Sign in with your
// organization.") -- else ours (a network failure has no body).
export const signupFailureMessage = err => {
  const body = err && err.data && typeof err.data === 'object' ? err.data : null
  const message = body && typeof body.message === 'string' ? body.message.trim() : ''
  return message && !GENERIC.test(message) ? message : SIGNUP_FAILED
}

export const SelfRegister = () => {
  const { identifier } = useParams()

  const [result, updateResult] = useState(null)
  const [error, updateError] = useState(null)

  const apFormSelfRegister = useApFormSelfRegister()

  useLoad(() => apFormSelfRegister.get(`${identifier}/init`), [])

  // A refusal is shown under the Signup button, as written (never
  // capitalized word by word), with its reference; the next try clears it.
  const handleSubmit = async data => {
    updateError(null)
    try {
      const result = await apFormSelfRegister.postArg('/register', data)
      updateResult(result)
    } catch (e) {
      updateError({ message: signupFailureMessage(e), failure: e })
    }
  }

  const handleDismiss = () => {
    apFormSelfRegister.get(`${identifier}/init`)
    updateResult(null)
    updateError(null)
  }

  let backgroundColor = useMemo(() => apFormSelfRegister.form.colorBackground || 'white', [apFormSelfRegister.form])

  return (
    <div className="d-flex flex-column h-100 p-1" style={{ backgroundColor: backgroundColor }}>
      <div className="flex-fill overflow-y-scroll">
        <div className="container h-100">
          <SelfRegisterHeroImage identifier={apFormSelfRegister.form.identifier} />

          {result
            ? <SelfRegisterResult apFormSelfRegister={apFormSelfRegister} onDismiss={handleDismiss} />
            : <SelfRegisterForm apFormSelfRegister={apFormSelfRegister} onSubmit={handleSubmit} error={error} onDismissError={() => updateError(null)} />}
        </div>
      </div>
      <div>
        <Footer />
      </div>
    </div>
  )
}
